import React, { useState ,useEffect } from "react";
import './App.css';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import 'react-datepicker/dist/react-datepicker.css';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Table, TableBody, TableContainer, TableHead, TableRow, 
} from '@mui/material';


import CssBaseline from '@mui/material/CssBaseline';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';

import TextField from '@mui/material/TextField';

import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
 import getSignUpTheme from './theme/getSignUpTheme';
 import {  SitemarkIcon } from './CustomIcons';
 import TemplateFrame from './TemplateFrame';
 import TableCell, { tableCellClasses } from '@mui/material/TableCell';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignUpContainer = styled(Stack)(({ theme }) => ({
  height: '100%',
  padding: 4,
  backgroundImage:
    'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
  backgroundRepeat: 'no-repeat',
  ...theme.applyStyles('dark', {
    backgroundImage:
      'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
  }),
}));


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function App() {


  const [mode, setMode] = React.useState('light');
  const [showCustomTheme, setShowCustomTheme] = React.useState(true);
  const defaultTheme = createTheme({ palette: { mode } });
  const SignUpTheme = createTheme(getSignUpTheme(mode));
  
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [nameError, setNameError] = React.useState(false);
  const [nameErrorMessage, setNameErrorMessage] = React.useState('');

  const [loginStatus,setLoginStatus] =useState(false);

  const [mobileNo, setMobileNo] = useState('');
  const [smsData, setSmsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');


  useEffect(() => {


    const loginData = localStorage.getItem('plant');
    if (loginData) {

      setLoginStatus(true);

     }
    
    const savedMode = localStorage.getItem('themeMode');
    if (savedMode) {
      setMode(savedMode);
    } else {
      // If no preference is found, it uses system preference
      const systemPrefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
      setMode(systemPrefersDark ? 'dark' : 'light');
    }
    

  },[]);

  const toggleColorMode = () => {
    const newMode = mode === 'dark' ? 'light' : 'dark';
    setMode(newMode);
    localStorage.setItem('themeMode', newMode); // Save the selected mode to localStorage
  };

  const toggleCustomTheme = () => {
    setShowCustomTheme((prev) => !prev);
  };

  const validateInputs = () => {
    
    const password = document.getElementById('password');
    const name = document.getElementById('name');

    let isValid = true;

    if (!name.value || name.value.length < 1) {
      setNameError(true);
      setNameErrorMessage('User Name is required.');
      isValid = false;
    } else {
      setNameError(false);
      setNameErrorMessage('');
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage('Password must be at least 6 characters long.');
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }

   

    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const finalData = {
      user: data.get('name'),
      password: data.get('password'),
    };

    userLogin(finalData);

  };


  const fetchSmsStatus = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await fetch(`https://saapi.ifbsupport.com/api/SmsStatus?MobileNo=${mobileNo}`, {
        method: 'GET',
        headers: {
          'accept': '*/*',
          'Authorization': 'Basic U0FBUFA6aWZiQDMyMTQ1Ng==',
          'Cookie': 'ARRAffinity=e0277c187ff101436083bf16025459fcc388b421ee67c0fce49458a3b7f89455; ARRAffinitySameSite=e0277c187ff101436083bf16025459fcc388b421ee67c0fce49458a3b7f89455; visid_incap_2850639=qf1cwcOrTXqdhJXCBLsljO8GjGUAAAAAQUIPAAAAAABG86cUQ48EWprjpFMK/pPJ'
        }
      });

      const data = await response.json();
      setSmsData(data); 
      console.log(JSON.stringify(data))
      setLoading(false);


    } catch (err) {
      setError('Failed to fetch data');
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (mobileNo) {
      fetchSmsStatus();
    } else {
      setError('Please enter a valid mobile number');
    }
  };

  const getMessageStatusColor = (status) => {
    if (status === 'DELIVERED') return 'green';
    if (status === 'SUBMITTED') return 'orange';
    return 'red';
  };

  const logoutUser = (event) => {

      localStorage.clear();
      setLoginStatus(false);

  }

  function userLogin(data){

   console.log(JSON.stringify(data));


    fetch("https://api.ifbanalytics.com/v1/scm/login",{
    method: "POST",
    body: JSON.stringify(data),
    headers: {
        "Content-type": "application/json; charset=UTF-8",
        "auth-token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiQWNndXcwMSIsImV4cCI6MTc0MzI2NDg5MSwicGFzc3dvcmQiOiJBY0AzMDQwIyJ9.4lixw3FSbyvPL4tXKdroKYRSvWR8C5LeY7xLwC7uQd8"
    }
})

.then((res) => res.json())
.then((json) => {

console.log(JSON.stringify(json));

if(json){


  const plantNo = json.Data.plant
  localStorage.setItem("plant",plantNo);
  setLoginStatus(true);
}
else{
  setLoginStatus(false);
  alert("Please enter valid username and password")
}


})
.catch(err => {

   console.log(err);


});

}




  return (
    <div >


{loginStatus ?

<div >

<Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
             SMS Status
          </Typography>
          <Button 
          onClick={logoutUser}
          color="inherit">Logout</Button>
        </Toolbar>
      </AppBar>
    </Box>


<div style={{ padding: '20px' }} >

<Box component="section" sx={{ p: 2, border: '1px dashed grey' }}>
     
<TextField
  label="Mobile Number"
  value={mobileNo}
  onChange={(e) => setMobileNo(e.target.value)}
  variant="outlined"
  style={{ marginBottom: '20px' }}
/>
<Button sx={{ml:'10px',mt:'10px'}}variant="contained" color="primary" onClick={handleSearch}>
  Search
</Button>

</Box>



{loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {smsData.length > 0 && (
        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">Mobile</StyledTableCell>
                <StyledTableCell align="center">Message</StyledTableCell>
                <StyledTableCell align="center">Message Status</StyledTableCell>
                <StyledTableCell align="center">Delivery Time</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {smsData.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell align="center">{row.destinationAddress}</StyledTableCell>
                  <StyledTableCell align="center">{row.message}</StyledTableCell>
                  <StyledTableCell align="center" style={{ color: getMessageStatusColor(row.messageStatus) }}>
                    {row.messageStatus}
                  </StyledTableCell>
                  <StyledTableCell align="center">{new Date(row.deliveredTime).toLocaleString()}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
</div>
</div>

      :

      <>
     <TemplateFrame
      toggleCustomTheme={toggleCustomTheme}
      showCustomTheme={showCustomTheme}
      mode={mode}
      toggleColorMode={toggleColorMode}
    >
      <ThemeProvider theme={showCustomTheme ? SignUpTheme : defaultTheme}>
        <CssBaseline enableColorScheme />
        <SignUpContainer direction="column" justifyContent="space-between">
          <Stack
            sx={{
              justifyContent: 'center',
              height: '100dvh',
              p: 2,
            }}
          >
            <Card variant="outlined">
              <SitemarkIcon />
              <Typography
                component="h1"
                variant="h4"
                sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
              >
                Sign In
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
              >
                <FormControl>
                  <FormLabel htmlFor="name">User name</FormLabel>
                  <TextField
                    autoComplete="name"
                    name="name"
                    required
                    fullWidth
                    id="name"
                    placeholder="User Name"
                    error={nameError}
                    helperText={nameErrorMessage}
                    color={nameError ? 'error' : 'primary'}
                  />
                </FormControl>
               
                <FormControl>
                  <FormLabel htmlFor="password">Password</FormLabel>
                  <TextField
                    required
                    fullWidth
                    name="password"
                    placeholder="••••••"
                    type="password"
                    id="password"
                    autoComplete="new-password"
                    variant="outlined"
                    error={passwordError}
                    helperText={passwordErrorMessage}
                    color={passwordError ? 'error' : 'primary'}
                  />
                </FormControl>
                
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  onClick={validateInputs}
                >
                  Sign In
                </Button>
                
              </Box>
            
              
            </Card>
          </Stack>
        </SignUpContainer>
      </ThemeProvider>
    </TemplateFrame>
      
      </>
       

      }





    </div>

  );
}

export default App;
